module.exports = __webpack_public_path__ + "static/media/export-excel.9900dcd6.svg";